// import React, { useState, useEffect, useRef } from 'react';
// import JoditEditor from 'jodit-react';
// import axios from 'axios';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Base_Url } from '../config';

// const EditPage = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const editor = useRef(null);

//   const [formData, setFormData] = useState({
//     parent_routes: '',
//     route_id: null,
//     author: '',
//     content: '',
//     title: ''
//   });

//   const editorConfig = {
//     readonly: false,
//     height: "70vh",
//     minHeight: 500,
//     maxHeight: 1500,
//     buttons: [
//       'source', '|',
//       'bold', 'italic', 'underline', '|',
//       'font', 'fontsize', 'paragraph', '|',
//       'table', 'link', '|',
//       'left', 'center', 'right', '|',
//       'undo', 'redo', '|',
//       'fullsize'
//     ],
//     uploader: {
//       url: `${Base_Url}/upload-image`,
//       format: 'json',
//       method: 'POST',
//       isSuccess: (resp) => {
//         if (resp.imageUrl) {
//           setFormData(prev => ({
//             ...prev,
//             content: prev.content + `<img src="${resp.imageUrl}" alt="Uploaded image" />`
//           }));
//           return true;
//         }
//         return false;
//       }
//     }
//   };

//   useEffect(() => {
//     const fetchPage = async () => {
//       if (!id) return;
      
//       try {
//         setLoading(true);
//         const response = await axios.get(`${Base_Url}/pages/${id}`);
//         const pageData = response.data;
        
//         setFormData({
//           parent_routes: pageData.parent_route || '',
//           route_id: pageData.route_id || null,
//           author: pageData.author || '',
//           content: pageData.page_details || '',
//           title: pageData.page_title || ''
//         });
//       } catch (err) {
//         setError('Failed to fetch page details');
//         console.error('Error fetching page:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPage();
//   }, [id]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleContentChange = (newContent) => {
//     setFormData(prev => ({
//       ...prev,
//       content: newContent
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!formData.title.trim()) {
//       setError('Title is required');
//       return;
//     }

//     try {
//       setLoading(true);
//       await axios.put(`${Base_Url}/pages/${id}`, {
//         content: formData.content,
//         route_id: formData.route_id,
//         parent_routes: formData.parent_routes,
//         author: formData.author,
//         title: formData.title
//       });
      
//       navigate('/add-routes');
//     } catch (err) {
//       setError('Failed to update page');
//       console.error('Error updating page:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center min-vh-100">
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container py-4">
//       <div className="row justify-content-center">
//         <div className="col-12 col-xl-8">
//           <div className="card">
//             <div className="card-body">
//               <h1 className="card-title h3 mb-4">Edit Page</h1>
              
//               {error && (
//                 <div className="alert alert-danger" role="alert">
//                   {error}
//                 </div>
//               )}

//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <label className="form-label">
//                     Title <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     required
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">Route</label>
//                   <input
//                     type="text"
//                     name="parent_routes"
//                     value={formData.parent_routes}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     readOnly={!!formData.parent_routes}
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">Author</label>
//                   <input
//                     type="text"
//                     name="author"
//                     value={formData.author}
//                     onChange={handleInputChange}
//                     className="form-control"
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label className="form-label">Content</label>
//                   <div className="border rounded">
//                     <JoditEditor
//                       ref={editor}
//                       value={formData.content}
//                       config={editorConfig}
//                       onBlur={handleContentChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="d-flex justify-content-end gap-2">
//                   <button 
//                     type="button" 
//                     onClick={() => navigate('/pages')}
//                     className="btn btn-secondary"
//                   >
//                     Cancel
//                   </button>
//                   <button 
//                     type="submit"
//                     className="btn btn-primary"
//                     disabled={loading}
//                   >
//                     {loading ? 'Updating...' : 'Update Page'}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditPage;


import { useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import { Form, Button, Container } from 'react-bootstrap';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Base_Url } from '../config';
import { useEffect, useMemo, useRef, useState } from 'react';

const EditPageForm = () => {
  const { id } = useParams();
  const editor = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    title: '',
    parent_routes: '',
    route_id: null,
    author: '',
  });

  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch existing page data
  useEffect(() => {
    const fetchPageData = async () => {
      try {
        if (id) {
          const response = await axios.get(`${Base_Url}/pages/${id}`);
          const pageData = response.data;
          
          setFormData({
            title: pageData.page_title || '',
            parent_routes: pageData.parent_route || '',
            route_id: pageData.route_id,
            author: pageData.author || '',
          });
          
          setContent(pageData.page_details || '');
        }
      } catch (err) {
        console.error('Failed to fetch page data', err);
        alert('Error loading page data. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPageData();
  }, [id]);

  const editorConfig = useMemo(() => ({
    readonly: false,
    minHeight: 400,
    editHTMLDocumentMode: true,
    buttons: [
      'source',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'eraser',
      '|',
      'ul',
      'ol',
      'indent',
      'outdent',
      '|',
      'font',
      'fontsize',
      'paragraph',
      'lineHeight',
      'brush',
      '|',
      'superscript',
      'subscript',
      'classSpan',
      '|',
      'file',
      'image',
      'video',
      '|',
      'spellcheck',
      'speechRecognize',
      '|',
      'cut',
      'copy',
      'paste',
      'selectall',
      'copyformat',
      '|',
      'hr',
      'table',
      'link',
      'symbols',
      '|',
      'ai-commands',
      'ai-assistant',
      '|',
      'left',
      '|',
      'undo',
      'redo',
      '|',
      'find',
      'fullsize',
      'preview',
      'print',
      'about'
    ],
    plugins: [
      'add-new-line',
      'ai-assistant',
      'backspace',
      'bold',
      'class-span',
      'clean-html',
      'clipboard',
      'color',
      'copyformat',
      'delete-command',
      'drag-and-drop',
      'drag-and-drop-element',
      'dtd',
      'enter',
      'file',
      'focus',
      'font',
      'format-block',
      'fullsize',
      'hotkeys',
      'hr',
      'iframe',
      'image',
      'image-processor',
      'image-properties',
      'indent',
      'inline-popup',
      'justify',
      'key-arrow-outside',
      'limit',
      'line-height',
      'link',
      'media',
      'mobile',
      'ordered-list',
      'paste',
      'paste-from-word',
      'paste-storage',
      'placeholder',
      'powered-by-jodit',
      'preview',
      'print',
      'redo-undo',
      'resize-cells',
      'resize-handler',
      'resizer',
      'search',
      'select',
      'select-cells',
      'size',
      'source',
      'speech-recognize',
      'spellcheck',
      'stat',
      'sticky',
      'symbols',
      'tab',
      'table',
      'table-keyboard-navigation',
      'video',
      'wrap-nodes',
      'xpath'
    ],
    lists: {
      indent: true,
      startIndent: 20,
    },
  }), []); 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const submitData = {
      ...formData,
      content,
      route_id: parseInt(id, 10),
    };

    try {
      const response = await axios({
        method: 'PUT', // Using PUT for updates
        url: `${Base_Url}/pages/${id}`,
        data: submitData
      });

      if (response.status === 200 || response.status === 201) {
        alert('Page updated successfully!');
      }
    } catch (error) {
      console.error('Error updating page:', error);
      alert('Error updating page. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <Container className="py-4">
        <div className="text-center">Loading page data...</div>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <div className="col-12 col-lg-12 mx-auto">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>
              Title <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="Enter page title"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Route</Form.Label>
            <Form.Control
              type="text"
              name="parent_routes"
              value={formData.parent_routes}
              onChange={handleInputChange}
              placeholder="Enter route"
              readOnly
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Author</Form.Label>
            <Form.Control
              type="text"
              name="author"
              value={formData.author}
              onChange={handleInputChange}
              placeholder="Enter author"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Content</Form.Label>
            <div className="border rounded">
              <JoditEditor
                ref={editor}
                value={content}
                config={editorConfig}
                tabIndex={1}
                onBlur={(newContent) => setContent(newContent)}
                onChange={() => {}}
              />
            </div>
          </Form.Group>

          <div className="d-grid gap-2 mt-4">
            <Button 
              type="submit" 
              variant="primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Saving...' : 'Update Page'}
            </Button>
          </div>
        </Form>
      </div>
    </Container>
  );
};

export default EditPageForm;